import React from "react";
import PublicNavbar from "../components/PublicNavbar";
import PublicFooter from "../components/PublicFooter";

const PublicLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <PublicNavbar />
      <main className="flex-1 pt-20 lg:pt-24">
        {children}
      </main>
      <PublicFooter />
    </div>
  );
};

export default PublicLayout;
